import axios from "axios";
import { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Connexion from "../../Views/Register/Connexion";
import { MagasinContext } from "../../Context/MagasinContext";
import { useParams } from "react-router-dom";
export default function LoginService(){
  const [CompteEmail, setCompteEmail] = useState('');
  const [message, setMessage] = useState("");
  const { name }:any = useParams();
  const navigate = useNavigate(); 
  const magasinContext = useContext(MagasinContext);

  useEffect(() => {
    const visiteurId = localStorage.getItem("VisiteurId");
    const magasinId = localStorage.getItem("MagasinId");
    const commercialId = localStorage.getItem("CommercialId");
    const clientId = localStorage.getItem("ClientId");
    const roleName = localStorage.getItem("roleName");

    if (visiteurId) {
      navigate('/visiteurs');
    } else if (magasinId) {
      navigate(`/magasins/${magasinId}`);
    } else if (commercialId) {
      navigate(`/commercials/${commercialId}`);
    } else if (clientId) {
      navigate(`/clients/${clientId}`);
    } else if (roleName) {
      navigate('/home');
    }
  }, [navigate]);

  const [PopUp, setPopUp] = useState(false);
  const [commercialsList, setCommercialsList] = useState<any[]>([]);
  const [enCompteList, setEnCompteList] = useState<any[]>([]);
  const [showEnComptePopup, setShowEnComptePopup] = useState(false);
  const [defaultMagasin, setDefaultMagasin] = useState<any>(null);

  const [Password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  // Direct magasin navigation helper
  const loginAsMagasinDirect = (IdMagasin: any, NameMagasin: any, adresse: any) => {
    localStorage.setItem("MagasinId", IdMagasin);
    localStorage.setItem("MagasinName", NameMagasin);
    localStorage.setItem("adresse", adresse || "");
    setTimeout(() => {
      window.location.href = `/magasins/${IdMagasin}`;
    }, 1);
  };

  const handleSelectEnCompteSupplier = (supplierItem: any) => {
    if (!defaultMagasin) return;
    localStorage.setItem("MagasinId", defaultMagasin.id);
    localStorage.setItem("MagasinName", defaultMagasin.NomMagasin);
    localStorage.setItem("adresse", defaultMagasin.adresse_de_siege || "");
    localStorage.setItem("en_compte_active", "1");
    localStorage.setItem("en_compte_supplier_id", String(supplierItem.magasin_id));
    localStorage.setItem("en_compte_supplier_name", supplierItem.NomMagasin);
    localStorage.setItem("en_compte_solde", String(supplierItem.solde));

    setTimeout(() => {
      window.location.href = `/magasins/${defaultMagasin.id}`;
    }, 1);
  };

  const handleSelectEnCompteDefault = () => {
    if (!defaultMagasin) return;
    localStorage.removeItem("en_compte_active");
    localStorage.removeItem("en_compte_supplier_id");
    localStorage.removeItem("en_compte_supplier_name");
    localStorage.removeItem("en_compte_solde");
    loginAsMagasinDirect(defaultMagasin.id, defaultMagasin.NomMagasin, defaultMagasin.adresse_de_siege);
  };

  // Premium two-tone chime on login click
  const playLoginSound = () => {
    try {
      const ctx = new (window.AudioContext || (window as any).webkitAudioContext)();
      const playTone = (freq: number, start: number, dur: number) => {
        const osc = ctx.createOscillator();
        const gain = ctx.createGain();
        osc.type = 'sine';
        osc.frequency.value = freq;
        gain.gain.setValueAtTime(0.18, ctx.currentTime + start);
        gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + dur);
        osc.connect(gain);
        gain.connect(ctx.destination);
        osc.start(ctx.currentTime + start);
        osc.stop(ctx.currentTime + start + dur);
      };
      playTone(880, 0, 0.15);     // A5
      playTone(1318.5, 0.1, 0.2); // E6
    } catch (_) { /* silent fallback */ }
  };

  // const [messageEror, setMessageErors] = useState("");
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    const url = `${process.env.REACT_APP_PHP_APP_URL}/connexion`; 
    try {
      const response = await axios.post(url, { CompteEmail, Password }, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
        
      if (response.data.message === "magasins") {
        playLoginSound();
        const account = response.data.account;
        const IdMagasin = account.id || account.IdMagasin;
        const NameMagasin = account.NomMagasin;
        const adresse = account.adresse_de_siege || "";

        try {
          const enCompteRes = await axios.get(
            `${process.env.REACT_APP_PHP_APP_URL}/magasins/${IdMagasin}/check-en-compte`
          );
          if (enCompteRes.data?.magasins && enCompteRes.data.magasins.length > 0) {
            setEnCompteList(enCompteRes.data.magasins);
            setDefaultMagasin({ id: IdMagasin, NomMagasin: NameMagasin, adresse_de_siege: adresse });
            setShowEnComptePopup(true);
            setLoading(false);
            return;
          }
        } catch (err) {
          console.error("Error checking en_compte at login:", err);
        }

        loginAsMagasinDirect(IdMagasin, NameMagasin, adresse);
      } 
      
      else if (response.data.message === "commercials") {
            const accountData = response.data.account;

  if (Array.isArray(accountData)) {
    playLoginSound();
    setCommercialsList(accountData);
    setPopUp(true);
    setLoading(false);
    console.log("hna 1");

  } else {
    // Only one commercial - use per-magasin values from commercials_magasins (response.data.name)
    playLoginSound();
    const IdCommercial = accountData.id;
    const NameCommercial = accountData.Nom;
    const magasinAssoc = response.data.name; // This is the commercials_magasins row (per-magasin specific)

    // Prefer per-magasin values from commercials_magasins over global Google Sheet values
    const Tele = magasinAssoc?.Tele || accountData.Tele || "";
    const Solde = magasinAssoc?.Credit ?? magasinAssoc?.credit ?? accountData.Credit ?? "0";
    const RemiseGlobal = magasinAssoc?.RemiseGlobal ?? accountData.RemiseGlobal ?? "0";
    const IdMagasin = magasinAssoc?.IdMagasin || "";
    const NameMagasinc = magasinAssoc?.MagasinName || "";

    navigate(`/commercials/${IdCommercial}`);

    console.log("Per-magasin remise:", RemiseGlobal, "IdMagasin:", IdMagasin);
    localStorage.setItem('MagasinName', NameMagasinc);
    localStorage.setItem('Tele', Tele);
    localStorage.setItem('SoldeCommercial', String(Solde));
    localStorage.setItem('CommercialId', IdCommercial);
    localStorage.setItem('remise', String(RemiseGlobal));
    localStorage.setItem('CommercialName', NameCommercial);
    if (IdMagasin) {
      localStorage.setItem('magasin_connecte', String(IdMagasin));
    }

    magasinContext.setId({
      id: IdCommercial,
    });

    magasinContext.setNameMagasin({
      nameComercial: NameCommercial,
    });

    magasinContext.setmagasinCommercial({
      magasinCommercial: NameMagasinc,
    });

    magasinContext.setSoldeCommercial({
      SoldeCommercial: String(Solde),
    });

    magasinContext.setTeleCommecrial({
      TeleCommercial: Tele,
    });
  }
}

      else if (response.data.message === "clients") {
        playLoginSound();
        const IdClient = response.data.account.id;
        const AccountId = response.data.account_id || IdClient; // utilisateur__accounts.id for commandes
        const NameClient = response.data.account.NomClient;
        const IdMagasinLiee = response.data.account.idMagasin || response.data.account.IdMagasin;
        const NameMagasinLiee = response.data.name;
        navigate(`/clients/`+AccountId);
        localStorage.setItem('ClientId', AccountId); // Use account_id (utilisateur__accounts.id) as primary
        localStorage.setItem('ClientDynamicId', IdClient); // Keep the clients table id as fallback
        localStorage.setItem('ClientName', NameClient);
        if (IdMagasinLiee) {
          localStorage.setItem('idMagasinLiee', IdMagasinLiee.toString());
        }
        if (NameMagasinLiee) {
          localStorage.setItem('MagasinLieeName', NameMagasinLiee);
        }
        magasinContext.setId({
          id: AccountId,
        });
        magasinContext.setNameMagasin({
          nameClient: NameClient,
        });
      } 


      else if (response.data.message === "admin") {
        playLoginSound();
        navigate(`/home`);
        const role = response.data.message;
        localStorage.setItem('roleName', role);
        magasinContext.setNameMagasin({
          role: role,
        });

      }else if (response.data.message === "vous navez accune compte avec ce email" || response.data.message === "le mot de passe incorrect" || response.data.message === "False information") {
        setLoading(false);
        setMessage(response.data.message === "False information" ? "incorrect compte" : response.data.message);
        setTimeout(() => {
          setMessage("");
        }, 3000);

      } else if(response.data.message === "Visiteurs"){
      playLoginSound();
      localStorage.setItem("VisiteurId", response.data.account.id);
      localStorage.setItem("VisiteurName", response.data.account.Nom_Complet);
      localStorage.setItem("VisiteurAdresse", response.data.account.Adresse);
      localStorage.setItem("VisiteurTele", response.data.account.Tele);
      navigate('/visiteurs')
      }
      else if (response.data.message === "magasin bloqué") {
        setLoading(false);
        setMessage("ce magasin et bloqué");
        const timeoutId = setTimeout(() => {
          setMessage("")
          }, 3000);

      }  
      
    } catch (error) {
      console.error("error:", error);
      setLoading(false);
    }
}
return(
<>

<Connexion 
handleSubmit={handleSubmit}
Password={Password}
PopUp={PopUp}
commercialsList={commercialsList}
setCompteEmail={setCompteEmail}
CompteEmail={CompteEmail}
setPassword={setPassword}
message={message}
name={name}
loading={loading}
enCompteList={enCompteList}
showEnComptePopup={showEnComptePopup}
defaultMagasin={defaultMagasin}
onSelectEnCompteSupplier={handleSelectEnCompteSupplier}
onSelectEnCompteDefault={handleSelectEnCompteDefault}
onCloseEnCompte={() => setShowEnComptePopup(false)}
/>
</>
)
}